import type { Object3D } from 'three';

export type HitSurface = 'wall' | 'metal' | 'wood';

const WOOD_FLOOR = /foyer|hub|sec|wing|kitchen|locker|stash|desk/;

/** Classify a world hit mesh for impact SFX. */
export function hitSurfaceFromObject(obj: Object3D | null): HitSurface {
  let o: Object3D | null = obj;
  while (o) {
    const id = o.name;
    if (o.userData?.destructible === 'crate') {
      return o.userData.crateStyle === 'wood' ? 'wood' : 'metal';
    }
    if (o.userData?.destructible === 'alarm') return 'metal';
    if (
      id.startsWith('desk') ||
      id.startsWith('crate') ||
      (id.startsWith('floor') && WOOD_FLOOR.test(id))
    ) {
      return 'wood';
    }
    if (
      id.startsWith('vent_') ||
      id.startsWith('ramp_') ||
      id.startsWith('step_') ||
      id.startsWith('catwalk') ||
      id.startsWith('landing') ||
      id.startsWith('lip_cw') ||
      id.startsWith('lip_stair') ||
      id.startsWith('tank') ||
      id.startsWith('pillar') ||
      id.startsWith('rail') ||
      id.startsWith('jamb') ||
      id.startsWith('stall') ||
      id.startsWith('cabinet') ||
      id.startsWith('locker') ||
      id.includes('grate') ||
      id.includes('helmet')
    ) {
      return 'metal';
    }
    o = o.parent;
  }
  return 'wall';
}
